/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_UsernameInputs */

const en__field_username = /** @type {(inputs: _Field_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

const de__field_username = /** @type {(inputs: _Field_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzername`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {_Field_UsernameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_username = /** @type {((inputs?: _Field_UsernameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_UsernameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_username(inputs)
	return de__field_username(inputs)
});